import * as React from 'react';
import type { EntityType } from '@modules/build-hub-comment/types';
import { Avatar, AvatarFallback, AvatarImage } from '@rocco/components/avatar';
import { capitalizeFirstLetter } from '~/utils/stringHelper';
import { getInitials } from '~/modules/build-hub/utils/get-initials';

export interface Candidate {
    id: string;
    label: string;
    avatar: string | null;
    type: EntityType;
}

interface Props {
    query: string;
    candidates: Candidate[];
    highlightIndex: number; // 👈 new
    onSelect: (candidate: Candidate) => void;
    onCancel: () => void;
}

export function CommentAutoComplete({
    candidates,
    highlightIndex,
    onSelect,
}: Props) {
    if (candidates.length === 0) return null;

    return (
        <div className="absolute bottom-full z-10 mb-3 w-full overflow-hidden rounded-lg border bg-white shadow">
            {candidates.map((c, i) => {
                const isActive = i === highlightIndex;
                return (
                    <div
                        key={`${c.type}:${c.id}`}
                        className={`flex cursor-pointer items-center gap-3 px-3 py-2 ${
                            isActive
                                ? 'bg-brick-100 text-white'
                                : 'hover:bg-gray-100'
                        }`}
                        onClick={() => onSelect(c)}
                        tabIndex={0}
                    >
                        <Avatar size="square40" borderWidth="none">
                            <AvatarImage src={c.avatar ?? ''} alt={c.label} />
                            <AvatarFallback size="md">
                                {getInitials(c.label)}
                            </AvatarFallback>
                        </Avatar>
                        <div className="flex flex-col">
                            <span>{c.label}</span>
                            <small
                                className={
                                    isActive ? 'text-blue-700' : 'text-gray-400'
                                }
                            >
                                {capitalizeFirstLetter(c.type)}
                            </small>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
